import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

const CTA = ({ slice }) => {
  const {
    heading,
    subheading,
    action_label: actionLabel,
    action_url: actionURL,
  } = slice.primary
  return (
    <section>
      <Container>
        <div dangerouslySetInnerHTML={{ __html: heading.html }} />
        <p>{subheading}</p>
        <Button
          type="button"
          as="a"
          href={actionURL.url}
          target={actionURL.target}
        >
          {" "}
          {actionLabel || "link"}
        </Button>
      </Container>
    </section>
  )
}

CTA.propTypes = {
  slice: PropTypes.object.isRequired,
}

export default CTA

const Container = styled.div`
  width: 100%;
  margin-top: 10px;
  text-align: left;
`
const Button = styled.a`
  ${({ theme }) => theme.primaryButton};
  font-size: 20px;
  @media (min-width: ${({ theme }) => theme.media.tablet_min}) {
    font-size: 24px;
  }
`
